export default __webpack_public_path__ + "static/usda-logo-reverse-6f9bcff3490b3f51347aad202dc15c18.png";